import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import './CaseStudies.css';

const CaseStudies = () => {
  const { t, i18n } = useTranslation('common');
  const lang = i18n.language || 'en';
  const [caseStudies, setCaseStudies] = useState([]);
  const [filter, setFilter] = useState('all');
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [studiesRes, categoriesRes] = await Promise.all([
          axios.get(`/api/case-studies?lang=${lang}`),
          axios.get('/api/case-studies/meta/categories')
        ]);
        setCaseStudies(studiesRes.data.data || []);
        setCategories(categoriesRes.data.data || []);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [lang]);

  const filteredStudies = filter === 'all'
    ? caseStudies
    : caseStudies.filter(s => s.category === filter);

  return (
    <div className="case-studies-page">
      <section className="page-hero">
        <div className="container">
          <p className="page-label">{t('home.caseStudies.label')}</p>
          <h1>{t('nav.menu.insights.caseStudies')}</h1>
          <p className="page-description">{t('home.caseStudies.description')}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="filter-bar">
            <button
              className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
              onClick={() => setFilter('all')}
            >
              All
            </button>
            {categories.map((cat, index) => (
              <button
                key={index}
                className={`filter-btn ${filter === cat ? 'active' : ''}`}
                onClick={() => setFilter(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="case-studies-grid">
            {filteredStudies.map((study, index) => (
              <article key={study._id || index} className="case-study-card">
                <div className="case-study-image">
                  <div className="image-placeholder">
                    <span>{study.category}</span>
                  </div>
                </div>
                <div className="case-study-content">
                  <span className="category-tag">{study.category}</span>
                  <h3>{study.title}</h3>
                  <p>{study.excerpt}</p>
                  {study.results && (
                    <div className="results-row">
                      {study.results.slice(0, 3).map((r, i) => (
                        <div key={i} className="result">
                          <span className="value">{r.value}</span>
                          <span className="label">{r.metric}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  <Link to={`/case-studies/${study.slug}`} className="read-more">
                    {t('home.caseStudies.readStudy')} <FiArrowRight />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CaseStudies;
